import TestReducer from './TestReducer';
import SpiderReducer from './SpiderReducer';

const Store = {
    test: TestReducer,
    spider: SpiderReducer,
};

export default Store;